import { useMutation, UseMutationOptions } from 'react-query';
import apiClient from 'src/queries/apiClient';
import { ApiResponseType, responseWrapper } from 'src/queries/helpers';
import { TravelCompletionDetailResponse, UpsertTravelCompletionPayload } from './types';

export function useUpdateTravelCompletion(
  options?: UseMutationOptions<
    ApiResponseType<TravelCompletionDetailResponse>,
    Error,
    UpsertTravelCompletionPayload
  >
) {
  const {
    mutate: updateTravelCompletion,
    data,
    isLoading,
    isSuccess,
  } = useMutation<
    ApiResponseType<TravelCompletionDetailResponse>,
    Error,
    UpsertTravelCompletionPayload
  >({
    mutationFn: (payload: UpsertTravelCompletionPayload) =>
      responseWrapper(apiClient.updateTravelCompletion, [payload]),
    ...options,
  });

  return {
    updateTravelCompletion,
    data,
    isLoading,
    isSuccess,
  };
}
